<template>
    <div>
        <el-form inline size="small">
            <el-form-item label="平台类型" prop="platform_type">
                <el-select v-model="searchParams.platform_type" placeholder="请选择平台" style="width:100%"
                    @change="handlePlatformChange" clearable>
                    <el-option v-for="(value, key) in platform_type_List" :key="key" :label="value" :value="key" />
                </el-select>
            </el-form-item>
            <el-form-item label="店铺分组" prop="platform_type">
                <el-select v-model="searchParams.group_ids" placeholder="全部分组" clearable multiple collapse-tags
                    filterable @change="setChange">
                    <el-option v-for="item in groupList" :key="item.id" :label="item.name" :value="item.id" />
                </el-select>
            </el-form-item>

            <!-- <el-form-item label="店铺名" prop="mer_shop_id">
                    <el-input v-model="form.mer_shop_id" placeholder="请输入"></el-input>
                </el-form-item> -->
            <el-form-item label="店铺名" prop="mer_shop_id">
                <el-select v-model="searchParams.mer_shop_id" placeholder="请选择店铺" style="width:100%" filterable
                    clearable collapse-tags multiple>
                    <el-option v-for="item in searchFilterShopList" :key="item.mer_shop_id" :label="item.shop_name"
                        :value="item.mer_shop_id" />
                </el-select>
            </el-form-item>
            <el-form-item label="费用类型" prop="type">
                <el-select v-model="searchParams.type" placeholder="请选择费用类型" style="width:100%" clearable collapse-tags
                    multiple>
                    <el-option v-for="(value, key) in Reimbursement_Type_List" :key="key" :label="value" :value="key" />
                </el-select>
            </el-form-item>

            <el-form-item label="商品ID" prop="platform_product_id">
                <el-input v-model="searchParams.platform_product_id" placeholder="请输入" clearable></el-input>
            </el-form-item>

            <el-form-item label="费用日期" prop="reimbursement_at">
                <el-date-picker v-model="searchParams.reimbursement_at" type="daterange" align="right" unlink-panels
                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"
                    :picker-options="search_pickerOptions" clearable>
                </el-date-picker>
            </el-form-item>

            <el-form-item label="费用金额" prop="reimbursement_money">
                <el-input-number v-model="searchParams.reimbursement_money_start" :controls=false></el-input-number> -
                <el-input-number v-model="searchParams.reimbursement_money_end" :controls=false></el-input-number>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" size="small" @click="handleSearch">查询</el-button>
                <el-button size="small" @click="refresh">重置</el-button>
            </el-form-item>
        </el-form>
        <div style="margin-bottom: 15px;">
            <el-button plain size="small" @click="addReimbursement">新增报销</el-button>
            <el-button plain size="small" @click="handleDelete(2)">批量删除报销</el-button>
            <span
                style="margin-left: 10px; font-size: 14px; font-weight: 600; color: #1989fa; background-color: #e8f3ff; padding: 4px 10px; border-radius: 6px; border: 1px solid #d9ecff;">
                合计总费用：¥{{ sumTotalMoney }} 元
            </span>
        </div>
        <el-table ref="reimbursementTable" v-loading="loading" :data="tableData"
            :header-cell-style="{ background: '#eef1f6', color: '#606266' }" class="rc_table" row-key="id"
            :row-class-name="tableRowClassName" @selection-change="handleSelectionChange"
            @expand-change="handleExpandChange">
            <el-table-column type="selection" align="center" width="50"></el-table-column>
            <!-- <el-table-column type="expand" width="1" class-name="hidden-expand-column">
                <template #default="props">
                    <div v-if="props.row.children && props.row.children.length" class="child-panel">
                        <div class="child-panel-title">费用分摊明细</div>
                        <div v-for="child in props.row.children" :key="child.id" class="child-row">
                            <span class="child-shop"><i class="el-icon-connection"></i>{{ shopName(child.mer_shop_id) }}</span>
                            <span class="child-money">¥{{ Number(child.reimbursement_money || 0).toFixed(2) }}</span>
                        </div>
                    </div>
                </template>
</el-table-column> -->
            <!-- <el-table-column label="序号" align="center" width="80">
                <template #default="{ $index }">{{ $index + 1 }}</template>
            </el-table-column> -->
            <el-table-column align="center" label="费用类型" prop="type" show-overflow-tooltip>
                <template #default="{ row }">
                    <el-tag :type="getTagType(row.type)" size="small">
                        {{ Reimbursement_Type_List[row.type] || '未知' }}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column align="center" label="平台" prop="platform_type" show-overflow-tooltip>
                <template #default="{ row }">
                    <el-tag :type="getTagType(row.platform_type)" size="small">
                        {{ platform_type_List[row.platform_type] || '未知' }}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column align="center" label="店铺" prop="mer_shop_id" show-overflow-tooltip>
                <template #default="{ row }">
                    <!-- <el-button v-if="hasChildren(row)" class="shop-expand-button" size="mini" @click.stop="toggleChildren(row)">
                        <i :class="isExpanded(row) ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i>
                    </el-button> -->
                    {{shop_List.find(item => item.mer_shop_id == row.mer_shop_id)?.shop_name || ''}}
                </template>
            </el-table-column>
            <!-- <el-table-column label="店铺" prop="mer_shop_id" align="center"></el-table-column> -->
            <el-table-column label="商品ID" prop="platform_product_id" align="center"></el-table-column>
            <el-table-column label="费用日期" prop="reimbursement_at" align="center"></el-table-column>
            <el-table-column label="费用凭证" min-width="120" max-width="250" align="center">
                <template #default="{ row }">
                    <!-- 只展示图片：先过滤出所有图片url -->
                    <div class="goods_wrap" v-if="getImageUrls(row.pay_record).length">
                        <div class="img_box">
                            <img class="coverimg" :src="getImageUrls(row.pay_record)[0]" alt="费用凭证"
                                @click="openImgPreview(getImageUrls(row.pay_record), 0)" />
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="费用金额" prop="reimbursement_money" align="center"></el-table-column>
            <el-table-column label="费用备注" prop="reimbursement_msg" align="center" min-width="100" max-width="150"
                show-overflow-tooltip></el-table-column>
            <el-table-column label="创建时间" prop="created_at" align="center"></el-table-column>
            <el-table-column label="操作" align="center" width="300">
                <template #default="{ row }">
                    <template v-if="!isChildRow(row)">
                        <el-button type="primary" @click="handleView(row)" size="mini">查看</el-button>
                        <el-button type="primary" @click="handleUpdate(row)" size="mini">修改</el-button>
                        <el-button type="primary" @click="handleDelete(1, row)" size="mini">删除</el-button>
                    </template>
                </template>
            </el-table-column>
        </el-table>

        <Pagination :total="page_data.total" :page.sync="page_data.page" :limit.sync="page_data.limit"
            @pagination="getDataList" layout="total, sizes, prev, pager, next, jumper" v-if="page_data.total > 0" />
        <!-- 弹窗：新增/修改/查看 通用 -->
        <el-image ref="globalImg" style="display: none;" :src="currentPreviewUrl"
            :preview-src-list="currentPreviewUrlList"></el-image>
        <el-dialog :title="dialogTitle" v-if="dialogVisible" :visible.sync="dialogVisible" width="600px"
            :close-on-click-modal="false">
            <el-form :model="form" :rules="rules" ref="formRef" label-width="100px">
                <!-- 平台类型：自动循环对象 -->
                <el-form-item label="平台类型" prop="platform_type">
                    <el-select v-model="form.platform_type" placeholder="请选择平台" style="width:100%"
                        @change="handlePlatformChange" clearable>
                        <el-option v-for="(value, key) in platform_type_List" :key="key" :label="value" :value="key" />
                    </el-select>
                </el-form-item>

                <!-- <el-form-item label="店铺名" prop="mer_shop_id">
                    <el-input v-model="form.mer_shop_id" placeholder="请输入"></el-input>
                </el-form-item> -->
                <el-form-item label="店铺名" prop="mer_shop_id">
                    <el-select v-model="form.mer_shop_ids" placeholder="请选择店铺" style="width:100%" filterable clearable
                        multiple collapse-tags @change="syncAllocations">
                        <el-option v-for="item in filterShopList" :key="item.mer_shop_id" :label="item.shop_name"
                            :value="item.mer_shop_id" />
                    </el-select>
                </el-form-item>
                <el-form-item label="费用分摊">
                    <el-radio-group v-model="form.allocation_type" @change="syncAllocations"><el-radio
                            :label="1">平摊</el-radio><el-radio :label="2">自填</el-radio></el-radio-group>
                    <el-button style="margin-left: 3px;" v-if="!form.mer_shop_ids.length && form.allocation_type" type="text" size="mini" @click="clearAllocation">取消分摊</el-button>
                    <div v-if="form.allocation_type === 2" class="allocation-shop-list">
                        <div v-for="shop in allocationShopList" :key="shop.mer_shop_id" class="allocation-shop-item">
                            <span class="allocation-shop-name" :title="shop.shop_name">{{ shop.shop_name }}</span>
                            <el-input-number v-model="form.shop_allocations[shop.mer_shop_id]" :precision="2" :min="0"
                                :controls="false" size="mini" />
                        </div>
                    </div>
                </el-form-item>
                <el-form-item prop="type">
                    <template #label>
                        <span>费用类型</span>
                        <el-tooltip content="可选择已有类型，也可直接输入选择可新建费用类型" placement="top">
                            <i class="el-icon-question"
                                style="color: #999; font-size: 14px; margin-left: 4px; cursor: pointer;"></i>
                        </el-tooltip>
                    </template>
                    <el-select v-model="form.type" placeholder="直接输入选择可新建费用类型" style="width:100%" clearable filterable
                        allow-create>
                        <el-option v-for="(value, key) in Reimbursement_Type_List" :key="key" :label="value"
                            :value="key" />
                    </el-select>
                </el-form-item>

                <el-form-item label="商品ID" prop="platform_product_id">
                    <el-input v-model="form.platform_product_id" placeholder="请输入" clearable></el-input>
                </el-form-item>

                <el-form-item label="费用日期" prop="reimbursement_at">
                    <el-date-picker v-model="form.reimbursement_at" align="right" type="date" value-format="yyyy-MM-dd"
                        placeholder="选择日期" :picker-options="pickerOptions" clearable>
                    </el-date-picker>
                </el-form-item>

                <el-form-item label="费用金额" prop="reimbursement_money">
                    <el-input-number v-model="form.reimbursement_money" :precision="4" :step="1" :min="0.1"
                        :max="100000"></el-input-number>
                </el-form-item>
                <el-form-item label="费用凭证" prop="pay_record">
                    <!-- <el-upload v-if="dialogType != 'view'" action="/api/upload" :file-list="form.pay_record" multiple
                        list-type="text" :limit="10" :on-success="handleUploadSuccess" :on-remove="handleUploadRemove"
                        :before-upload="beforeUpload">
                        <el-button size="small" type="primary">选择文件</el-button>
                        <div slot="tip" class="el-upload__tip">支持 jpg/png/pdf/doc/docx/xls/xlsx/txt，单文件最大5MB，最多上传10个
                        </div>
                    </el-upload> -->
                    <el-upload class="no-broken-img" ref="pay_record" style="display: inline-block;"
                        list-type="picture" :http-request="uploadAttachment"
                        :on-success="handleUploadSuccess" :on-change="handleUploadChange" :limit="10"
                        :file-list="fileList" :on-preview="handleOpen" :on-remove="handleUploadRemove"
                        :before-upload="beforeUpload" :disabled="batchUploading">
                        <el-button type="primary" v-if="dialogType != 'view'" size="small" :loading="batchUploading"
                            :disabled="batchUploading">
                            {{ batchUploading ? '上传中...' : `批量上传` }}
                        </el-button>
                        <div v-if="dialogType != 'view'" slot="tip" class="el-upload__tip">支持
                            jpg/jpeg/png/pdf/doc/docx/xls/xlsx/txt，单文件最大5MB，最多上传10个</div>
                        <!-- <template #file="{ file }">
                            <div style="display: flex;align-items: center;gap: 8px;">
                                <span style="color:#409eff;cursor:pointer;" @click="handleOpen(file)">
                                    {{ file.name }}
                                </span>
                                <el-button size="mini" @click="handleOpen(file)">
                                    {{ isImage(file.url) ? '查看' : '下载' }}
                                </el-button>
                                <el-button size="mini" v-if="dialogType != 'view'"
                                    @click="handleUploadRemove(file, fileList)">删除
                                </el-button>
                            </div>
                        </template> -->
                    </el-upload>
                </el-form-item>

                <el-form-item label="费用备注" prop="reimbursement_msg">
                    <el-input v-model="form.reimbursement_msg" type="textarea" rows="3" placeholder="请输入备注"
                        clearable></el-input>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="handleSubmit" :loading="save_update_loading"
                    v-if="dialogType !== 'view'">确认保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import { createDirectUploadRequest } from "@/assets/js/utils/ossDirectUpload";

import Pagination from "@/components/pagination/pagination.vue";

export default {
    components: {
        Pagination,
    },
    computed: {
        ...mapState({
            users: (state) => state.login.userinfo
        }),
        // 根据平台类型自动过滤店铺
        filterShopList() {
            // 如果没选平台，直接返回空数组
            if (!this.form.platform_type) {
                return [];
            }
            // 筛选 shop_type == 选中的 platform_type 的店铺
            return this.shop_List.filter(item => item.shop_type == this.form.platform_type);
        },
        allocationShopList() {
            const selectedIds = this.form.mer_shop_ids || [];
            if (selectedIds.length) return this.filterShopList.filter(item => selectedIds.map(String).includes(String(item.mer_shop_id)));
            return this.dialogType === 'add' ? this.filterShopList : [];
        },
        searchFilterShopList() {
            // 如果没选平台，直接返回空数组
            if (!this.searchParams.platform_type) {
                return [];
            }
            // 筛选 shop_type == 选中的 platform_type 的店铺
            return this.shop_List.filter(item => item.shop_type == this.searchParams.platform_type);
        },
    },
    data() {
        return {
            loading: false,
            save_update_loading: false,
            tableData: [],
            Reimbursement_Type_List: [],
            platform_type_List: [],
            shop_List: [],
            page_data: {
                limit: 10,
                page: 1,
                total: 0,
            },
            searchParams: {
                platform_type: '',
                mer_shop_id: '',
                type: '',
                platform_product_id: '',
                reimbursement_at: '',
                reimbursement_money: '',
                reimbursement_money_start: 0,
                reimbursement_money_end: 10000,
            },
            dialogVisible: false,
            dialogType: "update",
            dialogTitle: "",
            // 表单
            form: {
                id: "",
                type: "",
                platform_type: "",
                mer_shop_id: "",
                mer_shop_ids: [], allocation_type: 0, shop_allocations: {},
                reimbursement_at: "",
                platform_product_id: "",
                reimbursement_money: "",
                reimbursement_msg: "",
                pay_record: [],
            },

            // 校验规则
            rules: {
                type: [{ required: true, message: "请选择费用类型", trigger: "change" }],
                platform_type: [{ required: true, message: "请选择平台", trigger: "change" }],
                mer_shop_id: [],
                reimbursement_money: [{ required: true, message: "请输入费用金额", trigger: "blur" }],
                reimbursement_at: [{ required: true, message: "请输入费用日期", trigger: "blur" }]
            },
            selectedRows: [], // 存放选中的行
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
                shortcuts: [{
                    text: '今天',
                    onClick(picker) {
                        picker.$emit('pick', new Date());
                    }
                }, {
                    text: '昨天',
                    onClick(picker) {
                        const date = new Date();
                        date.setTime(date.getTime() - 3600 * 1000 * 24);
                        picker.$emit('pick', date);
                    }
                }, {
                    text: '一周前',
                    onClick(picker) {
                        const date = new Date();
                        date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', date);
                    }
                }]
            },
            search_pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            sumTotalMoney: 0,
            expandedRowIds: [],
            groupList: [],
            batchUploading: false,
            fileList: [],
            currentPreviewUrl: '',
            currentPreviewUrlList: [],

        }
    },
    created() {
        this.initData()
        this.getMerchantAllShopList()
        this.loadGroupList()
    },
    methods: {
        ...mapActions({
            opGetUserReimbursement: 'ucenter/opGetUserReimbursement',
            opGetMerchantAllShopList: 'ucenter/opGetMerchantAllShopList',
            opSaveUserReimbursement: 'ucenter/opSaveUserReimbursement',
            opUpdateUserReimbursement: 'ucenter/opUpdateUserReimbursement',
            opDeleteUserReimbursement: 'ucenter/opDeleteUserReimbursement',
            getShopBoardGroupList: "shop_board/getShopBoardGroupList",
        }),
        initData() {
            this.getDataList()
        },
        loadGroupList() {
            this.getShopBoardGroupList({
                data: {},
                success: (res) => {
                    if (res.code === 200) {
                        this.groupList = res.data || [];
                    } else {
                        this.$message.error(res.message || '获取分组失败');
                    }
                }
            });
        },
        setChange(val) {
            // if (this.$store.state.login.user_level == 9 && this.searchParams.group_ids) {
            //     this.searchParams.group_ids = []
            //     this.$message.error('普通会员无法使用分组');
            //     return
            // }
        },
        getDataList() {
            this.tableData = []
            this.expandedRowIds = []
            this.loading = true
            let param = { page_size: this.page_data.limit, page: this.page_data.page, ...this.searchParams }
            this.opGetUserReimbursement({
                data: param,
                success: (res) => {
                    this.loading = false
                    if (res.code == 200) {
                        this.tableData = res.data.list || []
                        this.Reimbursement_Type_List = res.data.Reimbursement_Type_List
                        this.platform_type_List = res.data.platform_type
                        this.page_data.total = res.data.total
                        this.sumTotalMoney = res.data.sumTotalMoney
                    } else {
                        this.$message.error(res.message)
                    }

                }
            })
        },
        handleSearch() {
            this.page_data.page = 1
            this.getDataList()
        },
        refresh() {
            this.tableData = []
            this.page_data.page = 1
            this.page_data.total = 0
            this.searchParams = {
                platform_type: '',
                mer_shop_id: '',
                type: '',
                platform_product_id: '',
                reimbursement_at: '',
                reimbursement_money: '',
                reimbursement_money_start: 0,
                reimbursement_money_end: 10000,
            }
            this.getDataList()
        },
        handleView(row) {
            this.dialogType = "view";
            this.dialogTitle = "查看费用";
            // 先重置表单
            this.form = {
                id: "",
                type: "",
                platform_type: "",
                mer_shop_id: "",
                mer_shop_ids: [],
                allocation_type: 0,
                shop_allocations: {},
                platform_product_id: "",
                reimbursement_at: "",
                reimbursement_money: "",
                reimbursement_msg: "",
                pay_record: [],
            };
            this.fileList = []
            // 再自动赋值
            Object.assign(this.form, row);
            this.form.mer_shop_ids = row.children?.length ? row.children.map(x => x.mer_shop_id) : (row.mer_shop_id ? [row.mer_shop_id] : []);
            this.form.allocation_type = Number(row.allocation_type || 0); this.form.shop_allocations = Object.fromEntries((row.children || []).map(x => [x.mer_shop_id, Number(x.reimbursement_money)]));
            this.form.platform_type = String(this.form.platform_type || '');
            this.form.type = String(this.form.type || '');
            const recordArr = Array.isArray(this.form.pay_record) ? this.form.pay_record : [];
            this.fileList = recordArr
                .filter(item => item?.url)
                .map(item => ({
                    name: item.object_name,
                    url: item.url
                }));
            this.dialogVisible = true;
        },
        handleUpdate(row) {
            this.dialogType = "update";
            this.dialogTitle = "修改报销";
            // 先重置表单
            this.form = {
                id: "",
                type: "",
                platform_type: "",
                mer_shop_id: "",
                mer_shop_ids: [],
                allocation_type: 0,
                shop_allocations: {},
                platform_product_id: "",
                reimbursement_at: "",
                reimbursement_money: "",
                reimbursement_msg: "",
                pay_record: [],
            };
            this.fileList = []
            // 再自动赋值
            Object.assign(this.form, row);
            this.form.mer_shop_ids = row.children?.length ? row.children.map(x => x.mer_shop_id) : (row.mer_shop_id ? [row.mer_shop_id] : []);
            this.form.allocation_type = Number(row.allocation_type || 0); this.form.shop_allocations = Object.fromEntries((row.children || []).map(x => [x.mer_shop_id, Number(x.reimbursement_money)]));
            this.form.platform_type = String(this.form.platform_type || '');
            this.form.type = String(this.form.type || '');
            const recordArr = Array.isArray(this.form.pay_record) ? this.form.pay_record : [];
            this.fileList = recordArr
                .filter(item => item?.url)
                .map(item => ({
                    name: item.object_name,
                    url: item.url
                }));
            this.dialogVisible = true;
        },
        handleDelete(type, row) {
            let del_ids = []
            if (type == 1) {
                del_ids.push(row.id)
            } else if (type == 2) {
                if (this.selectedRows.length === 0) {
                    this.$message.warning("请选择要删除的数据！");
                    return;
                }
                // 提取选中行的 ID 数组
                del_ids = this.selectedRows.map(item => item.id);
            }
            this.$confirm(`确定要删除 ${del_ids.length} 条报销数据吗？`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                this.opDeleteUserReimbursement({
                    data: { 'del_ids': del_ids },
                    success: (res) => {
                        if (res.code == 200) {
                            this.$message.success('删除成功')
                            this.refresh()
                        } else {
                            this.$message.error(res.message)
                        }
                    }
                })
            })

        },
        addReimbursement() {
            this.dialogType = "add";
            this.dialogTitle = "新增报销";
            this.form = {
                id: "",
                type: "",
                platform_type: "",
                mer_shop_id: "",
                mer_shop_ids: [], allocation_type: 1, shop_allocations: {},
                platform_product_id: "",
                reimbursement_at: new Date().toISOString().split('T')[0],
                reimbursement_money: "",
                reimbursement_msg: "",
                pay_record: [],
            };
            this.fileList = []
            this.dialogVisible = true;
        },
        // 控制tag颜色
        getTagType(channel) {
            switch (String(channel)) {
                case "1": return "primary";   // 蓝色 A
                case "2": return "success";   // 绿色 B
                case "3": return "warning";   // 黄色 C
                case "7": return "success";   // 黄色 C
                default: return "success";       // 灰色 未知
            }
        },
        handleSubmit() {
            this.$refs.formRef.validate((valid) => {
                // 校验失败
                if (!valid) {
                    this.$message.error('请完善必填项！')
                    return
                }
                const selectedShopIds = this.form.mer_shop_ids || []
                if (selectedShopIds.length > 1 && !this.form.allocation_type) { this.$message.error('请选择费用分摊类型'); return }
                this.save_update_loading = true
                const allocationShopIds = this.form.allocation_type ? this.allocationShopList.map(item => item.mer_shop_id) : selectedShopIds
                const submitData = { ...this.form, mer_shop_ids: allocationShopIds, mer_shop_id: allocationShopIds[0] || '' }
                if (allocationShopIds.length > 1 && submitData.allocation_type === 2 && Math.abs(allocationShopIds.reduce((total, id) => total + Number(submitData.shop_allocations[id] || 0), 0) - Number(submitData.reimbursement_money)) > 0.001) { this.$message.error('自填金额不等于费用金额'); this.save_update_loading = false; return }
                if (this.dialogType === 'add') {
                    this.opSaveUserReimbursement({
                        data: submitData,
                        success: (res) => {
                            this.save_update_loading = false
                            this.dialogVisible = false;
                            if (res.code == 200) {
                                this.$message.success('新增成功')
                                this.refresh()
                            } else {
                                this.$message.error(res.message)
                            }
                        }
                    })
                } else if (this.dialogType === 'update') {
                    this.opUpdateUserReimbursement({
                        data: submitData,
                        success: (res) => {
                            this.save_update_loading = false
                            this.dialogVisible = false;
                            if (res.code == 200) {
                                this.$message.success('修改成功')
                                this.getDataList()
                            } else {
                                this.$message.error(res.message)
                            }

                        }
                    })
                }

            })


        },
        getMerchantAllShopList() {
            this.opGetMerchantAllShopList({
                data: {},
                success: (res) => {
                    this.loading = false
                    if (res.code == 200) {
                        this.shop_List = res.data
                    } else {
                        this.$message.error(res.message)
                    }

                }
            })
        },
        handleSelectionChange(val) {
            this.selectedRows = val;
        },
        handlePlatformChange(val) {
            this.form.mer_shop_id = ''; this.form.mer_shop_ids = []; this.form.allocation_type = 0; this.form.shop_allocations = {};
            this.searchParams.mer_shop_id = '';
        },
        isChildRow(row) { return String(row.record_mode) === '3' || Number(row.parent_id || 0) > 0 },
        hasChildren(row) { return Array.isArray(row.children) && row.children.length > 0 },
        isExpanded(row) { return this.expandedRowIds.includes(row.id) },
        toggleChildren(row) { this.$refs.reimbursementTable.toggleRowExpansion(row) },
        handleExpandChange(row, expandedRows) { this.expandedRowIds = expandedRows.map(item => item.id) },
        shopName(id) { return this.shop_List.find(x => x.mer_shop_id == id)?.shop_name || id },
        tableRowClassName({ row }) { return row.children && row.children.length ? 'parent-row' : 'no-child' },
        clearAllocation() { this.form.allocation_type = 0; this.form.shop_allocations = {} },
        syncAllocations() { const shops = this.allocationShopList.map(item => item.mer_shop_id); if (this.form.allocation_type === 1) { const n = shops.length; const base = n ? Math.floor((Number(this.form.reimbursement_money || 0) / n) * 100) / 100 : 0; this.form.shop_allocations = {}; shops.forEach((s, i) => this.$set(this.form.shop_allocations, s, Number(i === 0 ? Number(this.form.reimbursement_money || 0) - base * (n - 1) : base).toFixed(2))) } else if (this.form.allocation_type === 2) { this.form.shop_allocations = shops.reduce((result, id) => { result[id] = this.form.shop_allocations[id] ?? ''; return result }, {}) } else this.form.shop_allocations = {} },
        beforeUpload(file) {
            // 限制格式示例，按需开启
            const allowType = [// 图片
                'image/jpeg',
                'image/jpg',
                'image/png',
                // PDF
                'application/pdf',
                // Word
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/msword',
                // Excel
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'application/vnd.ms-excel',
                // TXT 文本
                'text/plain'];
            if (!allowType.includes(file.type)) {
                this.$message.error('仅支持 jpg、png、pdf、word、excel、txt 格式');
                return false;
            }

            const isLt5M = file.size / 1024 / 1024 < 5;
            if (!isLt5M) {
                this.$message.error('文件大小不能超过 5MB！');
                return false;
            }
            return true;
        },
        handleUploadSuccess(res, file) {
            if (res.code == 200) {
                const url = res?.data?.url ?? '';
                if (url == '') {
                    this.$message.error('文件上传失败')
                }
                this.form.pay_record = this.form.pay_record || []
                const hasExist = this.form.pay_record.some(item => item.url === url);
                if (!hasExist) {
                    let fileinfo = { url: res?.data?.url ?? '', object_name: res?.data?.object_name ?? '', suffix: res?.data?.suffix ?? '', storage_path: res?.data?.storage_path ?? '' }
                    this.form.pay_record.push(fileinfo);
                } else {
                    this.$message.error('文件已上传过，请上传其他图片')
                }
            } else {
                this.$message.error('文件上传失败')
            }
            this.batchUploading = false;

        },
        uploadAttachment(options) {
            createDirectUploadRequest(options, { purpose: 'attachment' });
        },
        handleUploadRemove(file, fileList) {
            // 1. 从上传文件列表中移除当前文件（页面立刻消失）
            const idx = fileList.findIndex(f => f.uid === file.uid)
            if (idx > -1) {
                fileList.splice(idx, 1)
            }
            // 先收集当前页面所有有效 url
            const existUrls = fileList.map(item => item.url).filter(Boolean);

            // 过滤：只保留 url 还在 existUrls 里的对象
            this.form.pay_record = this.form.pay_record.filter(item => {
                return item && item.url && existUrls.includes(item.url);
            });
        },
        // 批量上传开始
        handleUploadChange(file) {
            if (file.status === 'ready') {
                this.batchUploading = true
            }
        },
        // 判断是否为图片
        isImage(url) {
            if (!url) return false
            const ext = url.split('.').pop().toLowerCase()
            return ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext)
        },

        // 点击文件名
        handleOpen(item) {
            const { url, name } = item
            if (!url) return

            if (this.isImage(url)) {
                this.currentPreviewUrl = ''
                this.currentPreviewUrlList = []
                this.$nextTick(() => {
                    this.currentPreviewUrl = url
                    this.currentPreviewUrlList.push(this.currentPreviewUrl)
                    this.$nextTick(() => {
                        const img = this.$refs.globalImg
                        if (img && img.clickHandler) {
                            img.clickHandler()
                        }
                    })
                })
            } else {
                // 非图片：下载文件
                const a = document.createElement('a')
                a.href = url
                a.download = name
                document.body.appendChild(a)
                a.click()
                document.body.removeChild(a)
            }
        },
        getImageUrls(list) {
            const arr = Array.isArray(list) ? list : []
            return arr.filter(item => this.isImage(item?.url)).map(item => item.url)
        },

        // 打开图片预览（支持多张，从当前点击索引开始）
        openImgPreview(imgList, startIndex) {
            this.currentPreviewUrl = imgList[startIndex]
            this.currentPreviewUrlList = imgList
            this.$nextTick(() => {
                // 触发 el-image 预览
                this.$refs.globalImg?.clickHandler?.()
            })
        }
    }
}
</script>


<style scoped>
.goods_wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
}

.allocation-shop-list {
    max-height: 180px;
    margin-top: 8px;
    padding-right: 8px;
    overflow-y: auto;
}

.allocation-shop-item {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
}

.allocation-shop-name {
    flex: 1;
    min-width: 0;
    margin-right: 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.allocation-shop-item .el-input-number {
    width: 120px;
    flex: 0 0 120px;
}

/* 图片固定大小，不缩放变形 */
.img_box {
    width: 110px !important;
    height: 110px !important;
    flex-shrink: 0 !important;
}

.coverimg {
    width: 100% !important;
    height: 100% !important;
    object-fit: cover !important;
    border-radius: 4px !important;
}

.tab-box {
    display: flex;
    justify-content: center;
    margin-bottom: 15px;
}

.w_120 {
    width: 150px;
}

.w_220 {
    width: 220px;
}

.goods_wrap {
    display: flex !important;
    align-items: flex-start !important;
    gap: 8px !important;
    width: 100% !important;
    box-sizing: border-box !important;
}

/* 图片固定大小，不缩放变形 */
.img_box {
    width: 110px !important;
    height: 110px !important;
    flex-shrink: 0 !important;
}

.coverimg {
    width: 100% !important;
    height: 100% !important;
    object-fit: cover !important;
    border-radius: 4px !important;
}

/* 内容区域自动适配 */
.con_box {
    flex: 1 !important;
    min-width: 0 !important;
    width: 100% !important;
}

/* 每行信息样式 */
.info-item {
    display: flex !important;
    align-items: center !important;
    font-size: 12px !important;
    margin: 0 0 3px 0 !important;
    line-height: 1.3 !important;
    width: 100% !important;
    white-space: normal !important;
    word-wrap: break-word !important;
}

/* 标签固定宽度，统一对齐 */
.label {
    min-width: 44px !important;
    flex-shrink: 0 !important;
    color: #666 !important;
    margin-right: 4px !important;
    font-size: 12px !important;
}

/* 标题文字自动换行，不撑破布局 */
.color {
    flex: 1 !important;
    word-break: break-all !important;
    white-space: normal !important;
}

/* ========== 修改输入框：全屏幕自动适配 ========== */
.edit-row {
    display: flex !important;
    align-items: center !important;
    width: 100% !important;
}

.edit-row .el-input {
    flex: 1 !important;
    max-width: 450px !important;
    min-width: 160px !important;
    width: auto !important;
}

.edit-row .el-button {
    flex-shrink: 0 !important;
    margin-left: 6px !important;
}

/* ========== 表格核心：允许内容自动换行 + 不隐藏 ========== */
.el-table .cell {
    white-space: normal !important;
    overflow: visible !important;
    height: auto !important;
    padding: 6px 0 !important;
}

/* 每行信息：自己占一行，但内容不换行 */
.info-item {
    font-size: 13px;
    color: #333;
    margin: 0 0 4px 0;
    line-height: 1.4;

    /* 关键：本行内部不换行 */
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* 标签灰色 */
.label {
    color: #666;
    margin-right: 4px;
}

/* 内容蓝色 */
.color {
    font-size: 12px;
    color: #0096ff;
}

/* 小屏幕自动适配：搜索表单缩小 + 自动换行 */
@media (max-width: 1445px) {
    .el-form--inline .el-form-item {
        margin-right: 8px !important;
        /* 缩小间距 */
    }

    .el-form--inline .el-form-item__label {
        padding: 0 6px !important;
        /* 标签间距缩小 */
        font-size: 12px !important;
        /* 标签文字变小 */
    }

    .el-form--inline .el-input,
    .el-form--inline .el-select {
        width: 130px !important;
        /* 输入框/下拉框变窄 */
    }

    .el-form--inline .el-button {
        padding: 6px 10px !important;
        /* 按钮变小 */
        font-size: 15px !important;
    }

    .img_box {
        width: 80px !important;
        height: 80px !important;
        flex-shrink: 0 !important;
    }

    .el-table,
    .el-table__cell,
    .info-item,
    .label,
    .color {
        font-size: 12px !important;
    }

    .no-padding-input>>>.el-input__inner {
        /* padding: 0 !important; */
        padding-left: 5px !important;
    }

    /* 整体容器 */
    /deep/ .no-broken-img .el-upload-list--picture .el-upload-list__item-thumbnail {
        /* 基础占位背景 */
        background-color: #f5f7fa;
        /* 清除默认图片、裂图背景 */
        background-image: none !important;
        /* 让内容溢出隐藏 */
        overflow: hidden;
    }

    /* 隐藏 Element 自带：加载失败图标、默认提示图标 */
    /deep/ .no-broken-img .el-upload-list__item-thumbnail::before,
    /deep/ .no-broken-img .el-upload-list__item-thumbnail::after {
        display: none !important;
        content: none !important;
    }

    /* 图片加载失败时，浏览器默认裂图图标隐藏 */
    /deep/ .no-broken-img .el-upload-list__item-thumbnail img {
        /* 图片加载失败不显示默认裂图 */
        object-fit: cover;
        background: transparent;
    }

    /* 关键：图片加载失败时，整体变为纯空白块 */
    /deep/ .no-broken-img .el-upload-list__item-thumbnail img:not([src]),
    /deep/ .no-broken-img .el-upload-list__item-thumbnail img[src=""] {
        display: none !important;
    }

}
</style>

<style>
.rc_table .parent-row>td {
    background: #edf5ff !important;
    font-weight: 600;
}

.rc_table .hidden-expand-column {
    padding: 0 !important;
}

.rc_table .hidden-expand-column .cell {
    display: none;
}

.rc_table .no-child .el-table__expand-icon {
    visibility: hidden;
}

.rc_table .el-table__expanded-cell {
    padding: 12px 20px 16px 62px !important;
    background: #f7faff;
}

.rc_table .child-panel {
    padding: 12px 18px;
    border-left: 4px solid #409eff;
    border-radius: 4px;
    background: #fff;
    box-shadow: 0 1px 4px rgba(64, 158, 255, .12);
}

.rc_table .child-panel-title {
    margin-bottom: 8px;
    color: #409eff;
    font-size: 13px;
    font-weight: 600;
}

.rc_table .child-row {
    display: flex;
    align-items: center;
    min-height: 34px;
    padding: 0 12px;
    border-top: 1px dashed #dcdfe6;
    color: #606266;
    font-size: 12px;
}

.rc_table .child-index {
    width: 42px;
    color: #909399;
}

.rc_table .child-index::before {
    content: '子';
    margin-right: 3px;
    color: #c0c4cc;
}

.rc_table .child-shop {
    flex: 1;
}

.rc_table .child-shop i {
    margin-right: 6px;
    color: #409eff;
}

.rc_table .child-money {
    min-width: 120px;
    color: #e6a23c;
    font-weight: 600;
    text-align: right;
}

.rc_table .shop-expand-button {
    width: 24px;
    height: 24px;
    margin-right: 6px;
    padding: 0;
    border-color: #b3d8ff;
    border-radius: 12px;
    color: #409eff;
    background: #fff;
}

.rc_table .shop-expand-button:hover {
    border-color: #409eff;
    color: #fff;
    background: #409eff;
}
</style>
